import { render, staticRenderFns } from "./WireTransferCard.vue?vue&type=template&id=152c3d14&scoped=true&"
import script from "./WireTransferCard.vue?vue&type=script&lang=js&"
export * from "./WireTransferCard.vue?vue&type=script&lang=js&"
import style0 from "./WireTransferCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WireTransferCard.vue?vue&type=style&index=1&id=152c3d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c3d14",
  null
  
)

export default component.exports